import { withTranslation } from 'react-i18next';

import Button from '@components/Common/Button';
import TeesterIcon from '@components/Common/TeesterIcon';

import style from './style.module.css';

const DeleteWindow = ({ t = () => {} }) => {
  return (
    <div className={style.root}>
      <TeesterIcon type="TRASH" color="red" />
      <h1>{t('Delete the picture!')}</h1>
      <p>{t('Do you really want to delete this picture?')}</p>
      <div className={style.buttonContainer}>
        <Button theme="SECONDARY" className={style.noButton}>
          {t('No')}
        </Button>
        <Button theme="PRIMARY">{t('Yes')}</Button>
      </div>
    </div>
  );
};

export default withTranslation()(DeleteWindow);
